export default __webpack_public_path__ + "d703ca0072be5912921d4428aa12c31d.svg";